import {Injectable, EventEmitter, OnInit} from "@angular/core";
import { resolve } from "url";
import { reject } from "q";

@Injectable({
  providedIn: 'root'
})
export class EmitserviceService {

  public eventEmit: any;
  public eventEmitClockInOrOut: any;//上下班

  constructor() {
      // 定义发射事件-鲜入为主活动二维码关闭回调
      this.eventEmit = new EventEmitter();

      //上下班回调
      this.eventEmitClockInOrOut = new EventEmitter();
  }

  ngOnInit() {

  }


  /**
   * 获取对象,例如：that.emitservice.eventEmit
   * 调用方式 this.get(that.emitservice.eventEmit).then(value=>{成功})
   * @param object 
   */
  get(object:any):Promise<any>{
    const that =this;
    // that["emitservice"].eventEmit.observers.length
    let msg:any={"message":"事件回传失败"}
    return new Promise<any>((resolve,reject)=>{
      if(object){
        try{
          object.observers=[];
          object.subscribe(value=>{
            resolve(value);
          });
        }catch(err){
          msg.message=err;
          reject(msg);
        }
      }else{
        msg.message="事件方法不存在";
        reject(msg);
      }
    });
  }
}
